enum ReportPresetEvents {
  ReportPresetOpened = 'ReportPresetOpened',
  ReportPresetCreated = 'ReportPresetCreated',
  ReportPresetUpdated = 'ReportPresetUpdated',
  ReportPresetDeleted = 'ReportPresetDeleted',
  ReportPresetSelected = 'ReportPresetSelected'
};
export default ReportPresetEvents;